{
  "it": {
    "dashboard": {
      "greetings": {
        "afternoon": "Buon pomeriggio {first_name}",
        "evening": "Buonasera {first_name}",
        "morning": "Buongiorno {first_name}",
        "night": "Buonanotte {first_name}"
      },
      "milestones": {
        "caught_up_subtitle": "Al momento non ci sono elementi aperti.",
        "caught_up_title": "È tutto aggiornato",
        "completed_count": "{count} completati",
        "due_before": "Entro il {date}",
        "journey_no_active_subtitle": "Il percorso di questa unità non è ancora iniziato.",
        "journey_no_active_title": "Nessuna tappa attiva",
        "journey_select_unit_subtitle": "Scelga un'unità qui sopra per visualizzare il relativo percorso.",
        "journey_select_unit_title": "Selezioni un'unità",
        "journey_title": "Il Suo percorso",
        "open_action": "Apri",
        "previous_label": "Tappe precedenti",
        "progress_completed": "{completed} / {total} completati",
        "show_less": "Mostra meno",
        "show_more_tasks": "Mostra {count} altra attività | Mostra {count} altre attività",
        "status_active": "In corso",
        "status_completed": "Completata",
        "status_planned": "Pianificata",
        "todo_now_title": "Cosa fare ora",
        "upcoming_more": "{count} altre tappe in arrivo"
      },
      "titles": {
        "activityFeed": "Cronologia",
        "assignedTasks": "Le mie attività",
        "newsFeed": "Novità",
        "ongoingTickets": "In corso",
        "openTickets": "Aperte",
        "progress": "Avanzamento",
        "tickets": "Conversazioni",
        "totalTickets": "Tutte le conversazioni",
        "unreadTickets": "Non lette",
        "yourAssignedTickets": "Assegnate a Lei"
      }
    }
  }
}
